<template>
  <div class="onboarding-card text-center">
    <div class="ob-check-circle mx-auto">
      <i class="fa-solid fa-check"></i>
    </div>

    <p class="ob-subtitle mt-4">Vamos a construir tu sueño</p>

    <p class="ob-footer">GRUPO TERRAZON SAPI DE CV</p>
  </div>
</template>

<script>
export default {
  name: 'PantallaConfirmacion',
};
</script>
